<template>
    <layout-internal-container>
        <div class="w-full flex flex-col gap-8">
            <div class="flex flex-col gap-4 md:flex-row items-end justify-between">
                <div class="flex flex-row gap-4 justify-between w-full">
                    <span class="text-sm text-gray-700 font-normal">Stay updated with the latest alerts and messages
                        tailored just for you.</span>
                    <!-- <div class="flex flex-row gap-2 items-center">
                        <span v-for="item in statusOption"
                            :class="item === statusActive ? 'bg-primary text-white' : 'bg-white border text-light'"
                            class="rounded-full px-3 py-1 items-center h-fit flex text-xs cursor-pointer"
                            @click="statusActive = item" :key="item">{{ item }}</span>
                    </div> -->
                    <div class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-2 w-fit" @click="readNotification('read-all')">
                        <span class="font-medium">Mark All As Read</span>
                    </div>
                </div>
            </div>
            
            <a-list item-layout="horizontal" :data-source="notifications" :bordered="false" :class="notifications.length == 0 ? 'hidden' : ''">
                <template #renderItem="{ item }">
                    <a-list-item class="hover:bg-primary hover:bg-opacity-5 cursor-pointer" @click="readNotification(item.id)">
                        <a-list-item-meta
                        >
                            <template #title>
                                <div class="flex flex-row justify-start gap-6 items-center">
                                    <div class="rounded-full p-3 " :class="item.read_at ? 'bg-gray-200 bg-opacity-60' : 'bg-primary bg-opacity-15'">
                                        <IconCheck size="24" class="text-primary"/>
                                    </div>
                                    
                                    <span class="text-[.9rem] font-normal leading-loose">{{ item.push_content }}</span>
                                </div>
                            </template>
                        </a-list-item-meta>
                    </a-list-item>
                </template>
            </a-list> 

            <div class="w-full h-[40vh] justify-center items-center" :class="notifications.length == 0 ? 'flex' : 'hidden'">
                <a-empty class="gap-3 flex items-center justify-center flex-col h-[20rem] w-full">
                    <template #description>
                        <span class="text-sm text-gray-500">
                            You don't have any notification yet
                        </span>
                    </template>
                </a-empty>
            </div>
        </div>
    </layout-internal-container>
</template>

  
<script setup>
import { onMounted, ref } from 'vue'
import axios from '@/plugins/axios';
import { IconArrowRight, IconClockHour3Filled, IconWifi, IconCheck } from '@tabler/icons-vue'
import { useRoute } from 'vue-router';

const statusOption = ref(['All', 'Following', 'Archived'])
const statusActive = ref('All')
const notifications = ref([])

const route = useRoute()

onMounted(() => {
    fetchNotification()
})

const fetchNotification = async () => {
    try {
        const response = await axios.get(`${route.path.toLowerCase().startsWith('/mentor') ? '/mentor' : ''}/notif/list`);

        notifications.value = response?.data
    } catch (error) {
        console.error('Error fetching notification:', error)
    }
}

const readNotification = async (id) => {
    try {
        await axios.post(`${route.path.toLowerCase().startsWith('/mentor') ? '/mentor' : ''}/notif/${id}` + (id != 'read-all' ? '/detail' : ''));
        fetchNotification();
    } catch (error) {
        console.error('Error fetching notification:', error)
    }
}
</script>
  